export default __webpack_public_path__ + "static/media/step1.9fc1ce52.svg";